import { HttpContextToken } from "@angular/common/http";

export const IS_SKIP_HANDLE_ERROR = new HttpContextToken<boolean>(() => false);
